@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-attribute-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.formContext"
                [attribute]="_context.formContext.item"
                (attributeUpdated)="onAttributeUpdated($event)"
                (canceled)="onCanceled($event)"></app-attribute-form>
        </mat-tab>
        @if (enumHelper.areEquals(PropertyType, _context.formContext.item.type, PropertyType.List) && _context.formContext.item.custom === true) {
            <mat-tab label="Valeurs">
                <app-attribute-value-form
                    [context]="_context.formContext"
                    (attributeValuesUpdated)="onattributeValuesUpdated($event)"
                    (needAttributeValuesRefreshed)="onNeedAttributeValuesRefreshed($event)"
                    (canceled)="onCanceled($event)"></app-attribute-value-form>
            </mat-tab>
        }
    </mat-tab-group>
}
